import MicRecorder from "./MicToMP3/index.js";
import React from "react";
import { toast } from "react-toastify";
import "./AudioRecorder.scss";
import { AudioPermissionIconHoc, RecordAudioHoc, StartRecordHoc, StopRecordHoc } from "../../../assets/images";
import { getFromLocalStorageAndDecrypt } from "../../../Helpers/Chat/webChatEncryptDecrypt";
import { blockOfflineMsgAction, setRecorder } from "../../../Helpers/Utility";
import { AUDIO_PERMISSION_DENIED, PERMISSION_DENIED } from "../../../processENV";
import Modal from "./Modal";

const getBlobDuration = (blob) => {
  const tempVideoEl = document.createElement("video");
  const durationP = new Promise((resolve) =>
    tempVideoEl.addEventListener("loadedmetadata", () => {
      resolve(Math.round(tempVideoEl.duration * 1000));
    })
  );
  tempVideoEl.src = typeof blob === "string" || blob instanceof String ? blob : window.URL.createObjectURL(blob);
  return durationP;
}

const AudioRecorder = (props = {}) => {
  const recorder = React.useMemo(() => new MicRecorder({ bitRate: 128 }), []);
  const [recordStatus, setRecordStatus] = React.useState(true);
  const [micStatus, setMicStatus] = React.useState(false);
  const [sendStatus, setSendStatus] = React.useState(false);
  const audioTimer = React.useRef(null);
  const { recordingStatus } = props;

  React.useEffect(()=>{    
    return(()=> {
      stopRecored()
    }) 
  },[])

  const stopRecored = () => {
    recorder.stop();
    setRecorder(null);
    clearTimeout(audioTimer.current);
    const container = document.getElementById("typingContainer");
    container && container.setAttribute("contentEditable", true);
    setRecordStatus(true);
    recordingStatus(true);
  };

  const autoStop = () => {
    recorder.stop();
    setRecorder(null);
    clearTimeout(audioTimer.current);
    toast.error("You can record maximum 300 seconds for audio recording");
  };

  const startTimer = (duration, display) => {
    let start = Date.now(),
      diff,
      minutes,
      seconds;
    function timer() {
      diff = duration - (((Date.now() - start) / 1000) | 0);
      duration - 1 === diff && setSendStatus(true); // For Restricting to Send Less than 1 Second
      minutes = (diff / 60) | 0;
      seconds = diff % 60 | 0;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      if(seconds>=0)
      {
      display.innerHTML =
        '<span class="recordMinutes">' + minutes + '</span>:<span class="recordSeconds">' + seconds + "</span>";
      }
      if (diff < 0) {
        autoStop();
      }
    }
    timer();
    audioTimer.current = setInterval(timer, 1000);
  };

    const sendRecored = () => {
    if (blockOfflineMsgAction()) return true;
    if (!sendStatus) return true;
    clearTimeout(audioTimer.current);
    setRecordStatus(true);
    recordingStatus(true);
    setSendStatus(false);
    setRecorder(null);
    recorder
      .stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const file = new File(buffer, "voice.mp3", {
          type: blob.type,
          lastModified: Date.now()
        }); 
        return getBlobDuration(blob).then(function (duration) {
          file.fileDetails = {
            duration: duration,
            audioType: "recording"
          };
          const container = document.getElementById("typingContainer");
          container && container.setAttribute("contentEditable", true);
          if(duration > 1000) return props.handleSendMediaMsg([file]);
          else toast.error("Recorded audio time is too short")

        });
      })
      .catch((e) => {
        console.log(e);
      })
    return sendStatus;
  };

  const startRecored = () => {
    if (blockOfflineMsgAction()) return;
    if(props.avoidRecord){
      toast("Unable to record audio while on call.");
      return;
    }
    let settings = JSON.parse(getFromLocalStorageAndDecrypt("settings"));
    const { audioLimit = 300 } = settings || {};
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: false })
      .then(function (permissionStatus) {
        if (permissionStatus.active) {
          setRecorder(recorder);
          setMicStatus(false);
          let sounds = document.getElementsByTagName("audio");
          for (const element of sounds) element.pause();
          recorder
            .start()
            .then(() => {
              setRecordStatus(false);
              recordingStatus(false);
              const container = document.getElementById("typingContainer");
              container && container.setAttribute("contentEditable", false);
              setTimeout(()=>startTimer(audioLimit, document.getElementById("recordDuration")))
            })
            .catch((e) => {
              console.error(e);
            });
        } else {
          setMicStatus(true);
        }
      })
      .catch((err) => {
        setMicStatus(true);
      });
  };

  const _handleaudioPopup = (e) => {
    setMicStatus(false);
  };

  return (
    <React.Fragment>
      {!recordStatus && (
        <div className="recordAudio">
          <div className="recordAudioInner">
            <i title="Stop record" className="stopRecord">
              <StopRecordHoc viewBox="0 0 30.114 30.122" onClick={stopRecored} />
            </i>
            <span className="liveRecord"></span>
            <span id="recordDuration" className="recordDuration"></span>
            <i title="Send record" className="sendRecord">
              <StartRecordHoc  viewBox="0 0 30.114 30.122" onClick={sendRecored} />
            </i>
          </div>
        </div>
      )}
      {recordStatus && (
        <div className="formbtns">
          <a type="" className="recordAudio" onClick={startRecored}>
            <i title="Record" className="recordAudioIcon">
              <RecordAudioHoc viewBox="0 0 13.247 18.738" />
            </i>
          </a>
        </div>
      )}
      {micStatus ? (
        <>
          <Modal containerId="container">
            <div className="camera-container mediaAttachCamera">
              <div className="camera-popup">
                <h4>{PERMISSION_DENIED}</h4>
                <i>
                  <AudioPermissionIconHoc />
                </i>
                <p>{AUDIO_PERMISSION_DENIED}</p>
                <div className="popup-controls">
                  <button
                    id={"jestBtnCancel"}
                    type="button"
                    name="btn-cancel"
                    className="btn-okay"
                    onClick={(e) => _handleaudioPopup(e)}
                  >
                    {"Okay"}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      ) : null}
    </React.Fragment>
  );
};

export default AudioRecorder;
